export default __webpack_public_path__ + "static/media/send-outline.ce2895c5.svg";